<template>
  <div class="col-md-4">
    <div class="c-mission__container" v-on:click="scrollToTop()">
      <div class="c-mission">
        <div class="c-mission__header">
          <span class="c-mission__type">{{$t('homepage.missions.' + type)}}</span>
          <img :src="'static/tempAssets/icon-'+type+'.svg'" alt class="c-mission__icon" />
        </div>
        <div class="c-mission__content">
          <p class="c-mission__title">{{title}}</p>
        </div>
      </div>
      <div class="c-mission__points__container">
        <div class="c-mission__points_box">
          <span class="c-mission__points__text">+ {{points}} punti</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    points: {
      type: Number,
      required: true
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

.c-mission__container {
  cursor: pointer;
  position: relative;
  background-color: #9ABBDA;
  border-radius: 15px;
  margin: 1rem 0;
  color: black;
  @include md {
    max-width: 350px;
    margin: 1rem auto;
    min-height: 16rem;
  }
  @include lg {
    min-width: auto;
    max-width: none;
    padding: 0 0.5rem;
    height: 100%;
    margin: 0;
  }
  @include xl {
    padding: 0 0.5rem;
  }
}

.c-mission {
  display: flex;
  flex-direction: column;
}
.c-mission__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.c-mission__icon {
  height: 40px;
}
.c-mission__points__container {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
}
.c-mission__content {
  padding: 1rem 1rem 5rem;
}
.c-mission__title {
  font-weight: 600;
  font-size: 20px;
  @include xl {
    font-size: 25px;
  }
}
.c-mission__type {
  font-weight: 600;
  font-size: 12px;
  @include xl {
    font-size: 15px;
  }
}
.c-mission__points_box {
  background-color: #9E8946;
  border-radius: 2px;
  padding: 1rem 2rem;
  width: 100%;
  border-top-left-radius: 15px;
  border-bottom-right-radius: 15px;
  font-weight: 600;
  color: white;
}
</style>